import { render, staticRenderFns } from "./NewCriterioCardMenu.vue?vue&type=template&id=f0f926a0"
import script from "./NewCriterioCardMenu.vue?vue&type=script&lang=js"
export * from "./NewCriterioCardMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports